import moment from 'moment';
import { observable } from 'mobx';
import io from 'socket.io-client';
import { gss } from '../component/lib/config';

const socket = io.connect(gss, {
  path: '/socket.io',
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: Infinity
});

export default class StationStore {
  @observable stations = [];
  @observable warningStatus = false;
  @observable dangerStatus = false;

  constructor() {
    this.connect();
    this.reconnect();
    this.fetchData();
  }

  connect(){
    socket.on('connect', () => {
      socket.emit('client_request', 'HPL');
    });
  }

  reconnect(){
    socket.on('reconnect', () => {
      socket.emit('client_request', 'HPL');
    });
  }

  fetchData(){
    try {
      socket.on('HPL', res => {
        this.warningStatus = false;
        this.dangerStatus = false;      
      if (!Array.isArray(res) || res.length===0) return;
      this.stations = res.map(station => {
        station= Object.assign(station, { warning: false, danger: false });
        if (!station.observations[0] || !station.observations[0].data || !station.observations[0].data.length) return station;
        let warningLevel = station.meta_data.find(item => item.name && item.name === 'Warning Level'),
          dangerLevel = station.meta_data.find(item => item.name && item.name === 'Danger Level');
  
        // dangerLevel.value = 588;

        if (!warningLevel && !dangerLevel) return station;

        
        let alert = this.isBetween(station.observations[0].data).reduce((acc, item) => {
          if (!!+item.value) {
            if (warningLevel &&!!+warningLevel.value) acc.warning = acc.warning || +item.value > +warningLevel.value;
            if (dangerLevel && !!+dangerLevel.value) acc.danger = acc.danger || +item.value > +dangerLevel.value;
          }
          return acc
        }, { warning: false, danger: false })
        this.warningStatus = this.warningStatus || alert.warning;
        this.dangerStatus = this.dangerStatus || alert.danger;
        return Object.assign(station, { alert });
      });
    })
 
    } catch (error) {
      console.error('Error handling socket event:', error);
    }
 
  }

  isBetween = (parameter) => {
    let between = [];
    if (parameter) {
      between = parameter.filter(obs => moment(obs.datetime).isBetween(moment().format('YYYY-MM-DDT00:00:00'), moment().format('YYYY-MM-DDT23:59:59')));
    }
    return between;
  }
}


// WEBPACK FOOTER //
// ./src/store/StationStore.js